import { createPermission } from '@backstage/plugin-permission-common';

export const customMetricsInsightsReadPermission = createPermission({
  name: 'custom-metrics.insights.read',
  attributes: { action: 'read' },
});

/**
 * Admin-level Insights permission.
 *
 * Must match the backend permission name so RBAC policies and
 * `usePermission` checks refer to the same logical permission.
 */
export const customMetricsInsightsAdminPermission = createPermission({
  name: 'custom-metrics.insights.admin',
  attributes: { action: 'read' },
});

export const customMetricsPermissions = [
  customMetricsInsightsReadPermission,
  customMetricsInsightsAdminPermission,
];
